import {
    BadgeStyled,
    Container,
    ContainerAvatar,
    ContainerData,
    ContentBadge,
    ContentDate,
    ContentLineClamp,
    ContentMessage,
    ContentName,
    ContentNameAndHour,
    ContentSocialMessage,
    ContentIconStatus,
    Text,
    TextMessage
} from "@dropDesk/presentation/components/internal_chat_list/styled";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import AvatarImage from "@dropDesk/presentation/components/avatar";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {formatDateChat} from "@dropDesk/utils/helpers/date_helper";
import {Tooltip} from "antd";
import HighLightWords from "@dropDesk/presentation/components/high_light_words";
import Status from "@dropDesk/presentation/components/messages/message_box/status_message/status";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";
import {BadgeOriginEnum} from "@dropDesk/domain/entities/ticket/ticket_maps";

const InternalChatList = (
    {
        internalChat,
        searchParam,
        onClick,
        idInternalChatSelected,
        userLogged,
        disabled
    }: {
        internalChat: InternalChatEntity
        userLogged: UserEntity
        searchParam: string,
        onClick: () => void,
        idInternalChatSelected?: string | null
        disabled: boolean
    }
) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <Container
            background={colors.onBackground}
            onClick={disabled ? () => {
            } : () => onClick()}
            isDarkenBackground={internalChat.id === idInternalChatSelected}
            disabled={disabled}
        >
            <ContainerAvatar>
                <AvatarImage
                    useCursorPointer={false}
                    title={internalChat.description ?? ''}
                    size={49}
                    letterSize={20}
                    url={undefined}
                    round={true}
                    hasPreviewImage={false}
                    withBorder={true}
                    alertPulseAnimation={!!internalChat.lastMessage?.isSystemMessage}
                    badgeOrigin={BadgeOriginEnum.internalChat}
                />
            </ContainerAvatar>
            <ContainerData bordercolor={colors.border}>

                <ContentNameAndHour>
                    <ContentName>
                        <Tooltip title={internalChat.description ?? ''} placement="right">
                            <ContentLineClamp color={colors.text} height={23}>
                                <HighLightWords
                                    searchWords={searchParam}
                                    textToHighlight={internalChat.description ?? ''}
                                />
                            </ContentLineClamp>
                        </Tooltip>

                    </ContentName>
                </ContentNameAndHour>

                <ContentMessage>
                    <ContentSocialMessage>
                        <ContentIconStatus>
                            {
                                !internalChat.lastMessage?.deleted &&
                                !internalChat.lastMessage?.isPrivate &&
                                internalChat.lastMessage?.senderId === userLogged.id &&
                                !internalChat.lastMessage?.reactionMessage &&
                                !internalChat.lastMessage?.isSystemMessage &&
                                <Status
                                    hint={colors.hint}
                                    status={internalChat.lastMessage?.getStatus(null, null, userLogged)}
                                />}

                            {internalChat.lastMessage?.deleted &&
                                <DropDeskIcon icon={ICONS_DROPDESK.block} size={11} color={colors.hint}/>}
                        </ContentIconStatus>
                        <ContentLineClamp height={20} color={colors.hint} style={{maxWidth: 200}}>
                            <Tooltip title={internalChat.lastMessage?.socialMessage ?? ''} placement="right">
                                <TextMessage
                                    color={colors.hint}>{internalChat.lastMessage?.socialMessage ?? ''}</TextMessage>
                            </Tooltip>
                        </ContentLineClamp>
                    </ContentSocialMessage>
                    <ContentDate height={20}>
                        <ContentDate height={23}>
                            <Text
                                color={colors.hint}>{internalChat.lastMessage?.createdAt ? formatDateChat(internalChat.lastMessage?.createdAt) : ''}</Text>
                        </ContentDate>
                        {!!internalChat.countUnreadNotification && idInternalChatSelected !== internalChat.id &&
                            <ContentBadge>
                                <BadgeStyled count={internalChat.countUnreadNotification} overflowCount={99}
                                             size="small"/>
                            </ContentBadge>
                        }
                    </ContentDate>
                </ContentMessage>

            </ContainerData>
        </Container>
    )
}
export default InternalChatList;
